module.exports = __webpack_public_path__ + "static/media/main idea.b49819c1.mp3";